import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Microsoft365LicensesView } from '../models/generated/ziroModels';

@Injectable({ providedIn: 'root' })
export class Microsoft365LicensesViewResource {
  private http = inject(HttpClient);

  getByTenantId(tenantId: number): Observable<Microsoft365LicensesView> {
    return this.http.get<Microsoft365LicensesView>(`/services/microsoft/views/tenants/${tenantId}/365-licenses`);
  }
}
